import { Messages } from '../../../../../../gen-src/Localize';
import { assertUnreachable } from '../../utils/TypescriptHelpers';

export enum LabelType {
  WARNING,
  DEPRECATED,
  STALE,
  MAINTENANCE,
  SENSITIVE_DATA,
  EXTRACT_REFRESH_FAILURE,
  FLOW_RUN_FAILURE,
  CERTIFIED
}

export function stringtoLabelType(type: string): LabelType {
  switch (type) {
    case LabelType[LabelType.WARNING]: return LabelType.WARNING;
    case LabelType[LabelType.DEPRECATED]: return LabelType.DEPRECATED;
    case LabelType[LabelType.STALE]: return LabelType.STALE;
    case LabelType[LabelType.MAINTENANCE]: return LabelType.MAINTENANCE;
    case LabelType[LabelType.SENSITIVE_DATA]: return LabelType.SENSITIVE_DATA;
    case LabelType[LabelType.EXTRACT_REFRESH_FAILURE]: return LabelType.EXTRACT_REFRESH_FAILURE;
    case LabelType[LabelType.FLOW_RUN_FAILURE]: return LabelType.FLOW_RUN_FAILURE;
    case LabelType[LabelType.CERTIFIED]: return LabelType.CERTIFIED;
    default: return LabelType.WARNING;
  }
}

export function labelTypeToString(type: LabelType): string {
  return LabelType[type];
}

export function localizeLabelTypeName(type: LabelType): string {
  switch (type) {
    case LabelType.WARNING:
      return Messages.DataQualityTypeWarning();
    case LabelType.DEPRECATED:
      return Messages.DataQualityTypeDeprecated();
    case LabelType.STALE:
      return Messages.DataQualityTypeStale();
    case LabelType.MAINTENANCE:
      return Messages.DataQualityTypeMaintenance();
    case LabelType.SENSITIVE_DATA:
      return Messages.DataQualityTypeSensitiveData();
    case LabelType.EXTRACT_REFRESH_FAILURE:
      return Messages.DataQualityTypeExtractRefreshFailure();
    case LabelType.FLOW_RUN_FAILURE:
      return Messages.DataQualityTypeFlowRunFailure();
    case LabelType.CERTIFIED:
      return Messages.DataQualityTypeCertified();
    default:
      assertUnreachable(type);
      return '';
  }
}
